import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/InstructorViewSubmission/PageProvider';
import Desktop from 'pages/ViewQuizSubmission/desktop';
import Mobile from 'pages/ViewQuizSubmission/mobile';
import Tablet from 'pages/ViewQuizSubmission/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const layouts = { desktop: Desktop, tablet: Tablet, mobile: Mobile };

const PageLayout = () => {
    const { isLoading } = useApp();
    const { device } = useViewport();
    const props = useContext(PageContext);
    const Layout = layouts[device];

    return isLoading || !props.currentSubmission || !props.form ? <Loading /> : <Layout {...props} />;
};

export default PageLayout;
